export default __webpack_public_path__ + "static/media/logo-noventi-dubidoc.d2ca6dd9.png";